import { createPlugin, formatVector } from 'leva/plugin'
import { Bezier } from './Bezier'
import { normalize, sanitize } from '../utilities/bezier-plugin'
import { InternalBezierSettings } from '../types/bezier-types'

export const bezier = createPlugin({
  normalize,
  sanitize,
  format: (value: any, settings: InternalBezierSettings) => formatVector(value, settings),
  component: Bezier,
})